import React from 'react';
import {get} from 'lodash';
import axios from 'axios';
import moment from 'moment';

import {
  metaLoading,
} from '../lib/helpers';

import {
  canEdit,
} from '../lib/policies';

import ImageLoader from './ImageLoader';
import DotTooltip from './DotTooltip';
import PostTextAndImages from './PostTextAndImages';
import Loading from './Loading';
import LoadMore from './LoadMore';
import ModalDelete from './ModalDelete';

class SharedPostLists extends React.Component {
  state = {
    ...metaLoading,
    posts: [],
  }

  componentDidMount = () => {
    this._load()
  }

  _load = () => {
    this.setState((prevState) => ({
      meta: {
        ...prevState.meta,
        isLoading: true,
      },
    }), () => {
      axios.get(`/${gon.currentProvider}/api/posts`, {
        params: {
          resource_id: get(this.props, 'resource.id'),
          resource_type: get(this.props, 'resource.type'),
          per: get(this.state, 'meta.per'),
          page: get(this.state, 'meta.page'),
        },
      })
        .then((res) => {
          this.setState((prevState) => ({
            meta: {
              ...prevState.meta,
              isLoading: false,
            },
          }), () => {
            const data = get(res, 'data.posts')

            if (res.status == 200 && data) {
              this.setState((prevState) => ({
                posts: [
                  ...prevState.posts,
                  ...data,
                ],
                meta: {
                  ...prevState.meta,
                  isFullyLoaded: get(data, 'length', 0) == 0 ? true : false,
                  page: get(prevState, 'meta.page') + 1,
                },
              }))
            }
          })
        })
    })
  }

  render() {
    return (
      <Loading
        isLoading={get(this.state, 'meta.isLoading') && get(this.state, 'posts.length', 0) == 0}
      >
        <div className='Group__posts'>
          {get(this.state, 'posts', []).map((post) => (
            <div
              key={post.id}
              className='Group__posts__item'
            >
              <div className='Group__posts__item__a'>
                <a href={`/${gon.currentProvider}/posts/${post.id}`}>{post.id}</a>
              </div>

              {canEdit('Post') &&
                <ModalDelete
                  type='post'
                  id={post.id}
                  klassName='Group__posts__item__handle'
                  reload
                  hideText
                />
              }

              <div className='Group__posts__item__content'>
                <div className='ImageBorder'>
                  <ImageLoader url={get(post, 'user.profileIcon.thumb.url')}/>
                </div>

                <div className='Group__posts__item__content__body'>
                  <div className='Group__posts__item__content__body__header'>
                    <div className='Group__posts__item__content__body__header__left'>
                      <strong>{get(post, 'user.nickname')}</strong>
                      <DotTooltip user={get(post, 'user')}/>
                    </div>

                    {get(post, 'inReplyToPost') &&
                      <div className='Group__posts__item__content__body__header__right'>
                        <small>Reply to</small> <a>{get(post, 'inReplyToPost.id')}</a>
                      </div>
                    }
                  </div>

                  <div className='Group__posts__item__content__body__center'>
                    <PostTextAndImages post={post} />

                    {get(post, 'inReplyToPost') &&
                      <div className='Group__posts__item__content__body__center__reply'>
                        <div className='Group__posts__item__content'>
                          <div className='ImageBorder'>
                            <ImageLoader url={get(post, 'inReplyToPost.user.profileIcon.thumb.url')}/>
                          </div>

                          <div className='Group__posts__item__content__body'>
                            <div className='Group__posts__item__content__body__header'>
                              <div className='Group__posts__item__content__body__header__left'>
                                <strong>{get(post, 'inReplyToPost.user.nickname')}</strong>
                                <DotTooltip user={get(post, 'inReplyToPost.user')}/>
                              </div>
                            </div>

                            <div className='Group__posts__item__content__body__center'>
                              <PostTextAndImages post={get(post, 'inReplyToPost')} />
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>

                  <div className='Group__posts__item__content__body__footer'>
                    <p><strong>Create at</strong> {moment(post.createdAt).format('YYYY-MM-DD HH:mm')}</p>
                    <p><strong>Reported count</strong> {post.reportedCount}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <LoadMore
            klassName='Group__posts__item Group__posts__item--load-more'
            onLoadMore={this._load}
            meta={this.state.meta}
          />
        </div>
      </Loading>
    );
  }
}

export default SharedPostLists
